module.exports = __webpack_public_path__ + "static/img/4.da8c026b.jpg";